// extracted by mini-css-extract-plugin
export var bubble = "_4f-0";
export var container = "_4f-f";
export var contrastBorder = "_4f-g";
export var greyOut = "_4f-2";
export var initialsColor0 = "_4f-3";
export var initialsColor1 = "_4f-4";
export var initialsColor10 = "_4f-d";
export var initialsColor11 = "_4f-e";
export var initialsColor2 = "_4f-5";
export var initialsColor3 = "_4f-6";
export var initialsColor4 = "_4f-7";
export var initialsColor5 = "_4f-8";
export var initialsColor6 = "_4f-9";
export var initialsColor7 = "_4f-a";
export var initialsColor8 = "_4f-b";
export var initialsColor9 = "_4f-c";
export var initialsWrapper = "_4f-1";
export var large = "_4f-l";
export var medium = "_4f-k";
export var mediumSmall = "_4f-j";
export var mediumSmallMedium = "_4f-o";
export var micro = "_4f-h";
export var small = "_4f-i";
export var tiny = "_4f-n";
export var xTiny = "_4f-m";